import {Async, Loaded, Loading } from 'Core/models/Async';
import {StringUnion} from 'Core/models/EmptyString';

export class UnassignedAgentNumber {
  public static create(agentNumber:StringUnion){
    return new UnassignedAgentNumber(agentNumber);
  }
  
  public readonly key = 'UnassignedAgentNumber';
  constructor(public readonly value : StringUnion){}
}

export class UserAssignedAgentNumber {
  public static create(agentNumber:string){
    return new UserAssignedAgentNumber(agentNumber);
  }

  public readonly key = 'UserAssignedAgentNumber';
  constructor(public readonly value : string){}
}

export class AgentNumberError {
  public static create(agentNumber:string){
    return new AgentNumberError(agentNumber);
  }
  
  public readonly key = 'AgentNumberError';
  constructor(public readonly value : string){}
}

export type AgentNumber = Async<string> | UnassignedAgentNumber | UserAssignedAgentNumber | AgentNumberError;

type MatchAgentNumberOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (agentNumber: string) => TReturn;
  Error: () => TReturn;
  Unassigned: (agentNumber: StringUnion) => TReturn;
  UserAssignedAgentNumber: (agentNumber: string) => TReturn;
  AgentNumberError: (agentNumber: string) => TReturn;
};

export const isLoading = (agentNumber: AgentNumber): agentNumber is Loading<string> =>
agentNumber.key === 'Loading';

export const isLoaded = (agentNumber: AgentNumber): agentNumber is Loaded<string> => agentNumber.key === 'Loaded';

export const isAgentNumberError = (agentNumber: AgentNumber): agentNumber is AgentNumberError =>
agentNumber.key === 'AgentNumberError';

export const matchAgentNumber = <TReturn>(options: MatchAgentNumberOptions<TReturn>) => (
    agentNumber: AgentNumber
) => {

  switch (agentNumber.key) {
    case 'UnassignedAgentNumber':
      return options.Unassigned(agentNumber.value);
    case 'Loaded':
      return options.Loaded(agentNumber.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
    case 'UserAssignedAgentNumber':
      return options.UserAssignedAgentNumber(agentNumber.value);
    case 'AgentNumberError':
      return options.AgentNumberError(agentNumber.value);
  }
};